import * as React from "react";
import { Fragment } from "react";
import ExpandMore from "@material-ui/icons/ExpandMore";
import List from "@material-ui/core/List";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Typography from "@material-ui/core/Typography";
import Collapse from "@material-ui/core/Collapse";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  icon: { minWidth: theme.spacing(5) },
  sidebarIsOpen: {
    "& a": {
      paddingLeft: theme.spacing(4),
      transition: "padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
    },
  },
  sidebarIsClosed: {
    "& a": {
      paddingLeft: theme.spacing(2),
      transition: "padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
    },
  },
}));

const SubMenu = (props) => {
  // const translate = useTranslate();
  const classes = useStyles();

  const header = (
    <MenuItem dense={props.dense} button onClick={props.handleToggle}>
      <ListItemIcon className={classes.icon}>
        {props.isOpen ? <ExpandMore /> : props.icon}
      </ListItemIcon>
      <Typography variant="inherit" color="textSecondary">
        {props.name}
      </Typography>
    </MenuItem>
  );

  return (
    <Fragment>
      {props.sidebarIsOpen || props.isOpen ? (
        header
      ) : (
        <Tooltip title={props.name} placement="right">
          {header}
        </Tooltip>
      )}
      <Collapse in={props.isOpen} timeout="auto" unmountOnExit>
        <List
          // dense={props.dense}
          component="div"
          disablePadding
          className={
            props.sidebarIsOpen
              ? classes.sidebarIsOpen
              : classes.sidebarIsClosed
          }
        >
          {props.children}
        </List>
      </Collapse>
    </Fragment>
  );
};

export default SubMenu;
